module.exports = __webpack_public_path__ + "img/89.7.Chla.0addc97f.png";